// extracted by mini-css-extract-plugin
module.exports = {"desktop":"AddToQueueButton_desktop__KGHu4","mobile":"AddToQueueButton_mobile__AA1DQ"};